<template>
    <div class="index">
        <!-- 导航栏 -->
        <div class="topNav">
            <div class="nav-box">
                <img class="nav-image" src="../../assets/index/logo.png">
                <span class="nav-title">山东省泰山教育创新研究院技能等级考试系统</span>
            </div>
        </div>

        <!-- 主页 -->
        <div class="index-view">
            <div class="index-search">
                <div class="search-title">考生成绩</div>
                <div class="input-item">
                    <div class="name-view">姓名</div>
                    <div class="view-item">{{ name }}</div>
                </div>

                <div class="input-item input-item2">
                    <div class="name-view">准考证号</div>
                    <div class="view-item">{{ number }}</div>
                </div>

                 <div class="input-item input-item2">
                    <div class="name-view">考试成绩</div>
                    <div class="view-item">{{ point }}</div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'result',
        data() {
            return {
               name: '',
               number: '',
               point: '' 

            }
        },
        created() {
            this.getResult()
            
        },
        methods: {
            getResult() {
                this.http.post('/exam/submitExam', {
                    userId: this.$store.state.login.userId,
                    recordId: this.$store.state.login.recordId,
                }).then(res=> {
                    this.name = res.data.result.username
                    this.number =  res.data.result.examNo
                    this.point =  res.data.result.point
                }) 
            }
        }
    }
</script>

<style lang="less" scoped>
    .index {
        width: 100%;
        min-height: 100vh;
        background: #368FCE;
        .topNav {
            width: 100%;
            height: 100px;
            background-color: #fff;
            .nav-box {
                width: 100%;
                padding: 20px 140px;
                box-sizing: border-box;
                display: flex;
                .nav-image {
                    width: 35px;
                    height: 35px;
                    margin-top: 8px;
                }
                .nav-title {
                    margin-left: 11px;
                    font-size: 36px;
                    font-weight: 500;
                    color: #368FCE;
                }
                
            }
        
        }
        .index-view {
            padding-top: 50px;
            box-sizing: border-box;
        }
        .index-search {
            width: 1200px;
            margin: 0 auto;
            background-color: #FFFFFF;
            border-radius: 15px;
            padding: 60px 81px 55px 102px;
            box-sizing: border-box;
            .search-title {
                font-size: 40px;
                font-weight: 500;
                color: #333333;
                text-align: center;
            }
            .input-item {
                width: 100%;
                display: flex;
                margin-top: 45px;
                margin-bottom: 5px;
                .name-view {
                    width: 150px;
                    font-size: 30px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 80px;
                    text-align-last: justify;
                }
                .view-item {
                    margin-left: 50px;
                    font-size: 30px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 80px;
                }
                
            }
            
        }
       
    }
</style>